import { observer } from 'mobx-react-lite'
import { type ReactNode } from 'react'
import { ChoiceTile, type IIconsVector } from 'shared/ui'
import { LINK_COMPLIANCE_LEARN_MORE_LINK } from 'shared/constants/links'
import { EnumOptInMethodTypes } from 'entities/Compliance'
import { LearnMoreLink } from 'pages/settings/ui/LearnMoreLink/LearnMoreLink'
import { PageDescription } from 'pages/settings/ui/PageDescription/PageDescription'
import { NextButton } from 'pages/settings/ui/NextButton/NextButton'
import styles from './styles.module.scss'

type IOptInMethodProps = {
  isNextDisabled: boolean
  stepLoading: boolean
  errorAlert?: ReactNode
  onNextClick: () => void
  isOptInMethodActive: (value: EnumOptInMethodTypes) => boolean
  setOptInMethods: (value: EnumOptInMethodTypes) => void
}

export const CommonOptInMethod = observer(
  ({
    isNextDisabled,
    stepLoading,
    errorAlert,
    onNextClick,
    isOptInMethodActive,
    setOptInMethods,
  }: IOptInMethodProps) => {
    const handleSetOptInMethod = (value: string) => setOptInMethods(value as EnumOptInMethodTypes)

    const optInMethods: { icon: IIconsVector; title: string; value: EnumOptInMethodTypes }[] = [
      {
        icon: 'monitor01',
        title: 'Online Form',
        value: EnumOptInMethodTypes.onlineForm,
      },
      {
        icon: 'testSMS',
        title: 'via Text',
        value: EnumOptInMethodTypes.text,
      },
      {
        icon: 'qrCode02',
        title: 'QR Code',
        value: EnumOptInMethodTypes.qrCode,
      },
      {
        icon: 'file02',
        title: 'Paper Form',
        value: EnumOptInMethodTypes.paperForm,
      },
    ]

    return (
      <div>
        <PageDescription>
          Select the option(s) around how your contacts opt-in to receive text messages, therefore
          giving consent to receive your messages.
          <LearnMoreLink href={LINK_COMPLIANCE_LEARN_MORE_LINK}>Learn more</LearnMoreLink>
        </PageDescription>

        {errorAlert}

        <div className={styles.wrap}>
          {optInMethods.map((method) => (
            <ChoiceTile
              key={method.value}
              iconProps={{
                fontSize: 20,
                icon: method.icon,
                color: isOptInMethodActive(method.value)
                  ? 'var(--content-brand-primary)'
                  : 'var(--content-primary-tertiary)',
              }}
              title={method.title}
              value={method.value}
              checked={isOptInMethodActive(method.value)}
              setChoiceTile={handleSetOptInMethod}
            />
          ))}
        </div>
        <div className={styles.stickyActions}>
          <NextButton
            loading={stepLoading}
            disabled={isNextDisabled || stepLoading}
            text='Next'
            onClick={onNextClick}
          />
        </div>
      </div>
    )
  }
)
